import { CanvasElementType } from '@y42/json-schema';
import type { VisualizationCanvasElementStoreModel } from '../../../state/canvas-element/visualization-canvas-element.model';

export type StickableItemType = CanvasElementType.Attention | CanvasElementType.Comment;
export type StickyItem = VisualizationCanvasElementStoreModel<StickableItemType>;

const stickableCanvasItemTypes = new Set([
  CanvasElementType.Attention,
  CanvasElementType.Comment,
  CanvasElementType.FreeAttentionNode,
]);
const nonAttachmentBaseCanvasItemTypes = new Set([...stickableCanvasItemTypes, CanvasElementType.Emoji]);

export const isStickyItem = (item: VisualizationCanvasElementStoreModel): item is StickyItem =>
  stickableCanvasItemTypes.has(item.type);

export const isAttachmentBaseItem = (item: VisualizationCanvasElementStoreModel) =>
  !nonAttachmentBaseCanvasItemTypes.has(item.type);

export enum AttachmentPositionType {
  TopLeft,
  TopRight,
  BottomLeft,
  BottomRight,
  Movable,
}

const itemTypeToAttachmentPositionType = {
  [CanvasElementType.FreeAttentionNode]: AttachmentPositionType.Movable,
  [CanvasElementType.Attention]: AttachmentPositionType.TopRight,
  [CanvasElementType.Comment]: AttachmentPositionType.Movable,
};

export function getAttachmentPositionType(item: StickyItem) {
  return itemTypeToAttachmentPositionType[item.type];
}
